export const FEATURE_NAME = '@zerops/zerops/feature/autoscaling-update-dialog';
